import { render } from "./WorkWithUs.vue?vue&type=template&id=34bbf8fc"
import script from "./WorkWithUs.vue?vue&type=script&lang=js"
export * from "./WorkWithUs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__